import { Component } from '@angular/core';
import { UntypedFormControl, FormGroup, Validators } from '@angular/forms';
import { LanguageService } from '@uigy/shared/services/language.service';
import { FormValidatorsService } from '@uigy/shared/services/form-validators.service';
import { GenericSliderPage } from '@uigy/shared/components/slider-v2/models/generic-slider-page';
import { RegexEnum, RegularExpressions } from '@uigy/shared/enums/regex.enum';

@Component({
    selector: 'app-license-code-dialog',
    templateUrl: './license-code-dialog.component.html',
    standalone: false
})
export class LicenseCodeDialogComponent implements GenericSliderPage<void, {code: string}> {
  public code = new UntypedFormControl('', [Validators.required, Validators.pattern(RegularExpressions[RegexEnum.licenseCode])]);
  public dialogTexts = this.languageService.texts.license_activation.step1.slider;

  constructor(private languageService: LanguageService, public formValidatorsService: FormValidatorsService) { }

  getData(): {code: string} {
    return {code: this.code.value};
  }

  initData(): void {}

  isValid(): boolean {
    return this.code.valid;
  }
}
